import type { StaffInventoryViewModel } from "@lumora/core";
import { useViewModel } from "@lumora/ui";

interface Props {
  vm: StaffInventoryViewModel;
}

export default function StaffInventoryView({ vm }: Props) {
  const state = useViewModel(vm);

  if (!vm.canView()) {
    return <p className="text-sm text-gray-500">Your role cannot view staff inventory.</p>;
  }

  return (
    <section className="space-y-4">
      <h2 className="text-lg font-bold">Inventory</h2>
      {state.error && <p className="text-sm text-red-600">{state.error}</p>}
      {state.loading && <p className="text-sm text-gray-500">Loading…</p>}
      <ul className="divide-y divide-gray-100 rounded-lg border border-gray-100 bg-white">
        {state.listings.map((item) => (
          <li key={item.id} className="flex flex-wrap items-center justify-between gap-3 p-4 text-sm">
            <div>
              <p className="font-semibold">
                {item.year} {item.make} {item.model}
              </p>
              <p className="text-gray-500">
                ${(item.priceCents / 100).toLocaleString()} · {item.status}
              </p>
            </div>
            {vm.canArchive() && item.status === "available" && (
              <button
                type="button"
                className="rounded bg-gray-900 px-3 py-1 text-xs font-bold uppercase text-white"
                onClick={() => void vm.archive(item.id)}
              >
                Archive
              </button>
            )}
          </li>
        ))}
      </ul>
      {!state.loading && state.listings.length === 0 && (
        <p className="text-sm text-gray-500">No listings yet.</p>
      )}
    </section>
  );
}
